import React from 'react';
import { commonStrings } from '../../content';
import BrandMark from './BrandMark';

/**
 * Renders the hobtalk loading mark experience.
 *
 * @param {object} props - Component properties.
 * @param {*} props.label - label value.
 * @returns {JSX.Element} The rendered interface.
 */
function HobtalkLoadingMark({ label = commonStrings.loading.generic }) {
  return (
    <div className="hobtalk-loading-mark" role="status" aria-live="polite">
      <BrandMark size="loader" />
      <span className="hobtalk-mark-glow hobtalk-mark-glow-orange" aria-hidden="true" />
      <span className="hobtalk-mark-glow hobtalk-mark-glow-teal" aria-hidden="true" />
      <span className="hobtalk-mark-glow hobtalk-mark-glow-blue" aria-hidden="true" />
      <span className="hobtalk-mark-glow hobtalk-mark-glow-cream" aria-hidden="true" />
      <span className="hobtalk-mark-glow hobtalk-mark-glow-sand" aria-hidden="true" />
      <span className="hobtalk-mark-center-glow" aria-hidden="true" />
      <span className="sr-only">{label}</span>
    </div>
  );
}

/**
 * Renders the hobtalk loader experience.
 *
 * @param {object} props - Component properties.
 * @param {*} props.label - label value.
 * @param {*} props.variant - variant value.
 * @returns {JSX.Element} The rendered interface.
 */
export default function HobtalkLoader({ label = commonStrings.loading.generic, variant = 'inline' }) {
  if (variant === 'page') {
    return (
      <div className="hobtalk-loader-page">
        <HobtalkLoadingMark label={label} />
      </div>
    );
  }

  if (variant === 'overlay') {
    return (
      <div className="hobtalk-loader-overlay">
        <div className="hobtalk-loader-overlay-card">
          <HobtalkLoadingMark label={label} />
          <span>{label}</span>
        </div>
      </div>
    );
  }

  return <HobtalkLoadingMark label={label} />;
}
